// Fix AC (2026-09-18): marca visual consistente en TODAS las pantallas que
// muestran el nombre de un usuario -- si la persona fue eliminada del
// sistema, se aclara acá al lado del nombre (el nombre en sí se sigue
// mostrando siempre, viene denormalizado o resuelto en vivo desde el
// backend, esto solo agrega el aviso).
export const DeletedUserBadge = ({ id }) => (
  <span
    className="badge gray"
    style={{ fontSize: 9, marginLeft: 6, whiteSpace: "nowrap" }}
    data-testid={id ? `deleted-user-badge-${id}` : "deleted-user-badge"}
    title="Este usuario fue eliminado del sistema -- se conserva su historial"
  >
    usuario eliminado
  </span>
);
